export default {"src":"/_next/static/media/crazy_white.69c7fcbf.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};